// Material Dashboard 2 React examples
import PropTypes from "prop-types";
import ApiDescription from "./ApiDescription";
import accountOpeningApiData from "./tableData";
import ScrollSpy from "react-ui-scrollspy";

function AccountOpeningDocs({ scrollRef, search }) {
  return (
    <ScrollSpy
      activeClass="ss-actives"
      offsetBottom={100}
      scrollThrottle={80}
      parentScrollContainerRef={scrollRef}
    >
      <ApiDescription data={accountOpeningApiData} search={search} />
    </ScrollSpy>
  );
}
AccountOpeningDocs.propTypes = {
  scrollRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  search: PropTypes.string.isRequired,
};
export default AccountOpeningDocs;
